import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

/**
 * Generates and downloads Excel from given data
 */
export async function exportToExcel(data, fileName = "data", columns = []) {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet 1");

  // Use provided columns or keys from first object
  const headers = columns.length
    ? columns.map((col) => ({
        header: col.header,
        key: col.accessor,
        width: col.width || 20,
      }))
    : Object.keys(data[0] || {}).map((key) => ({
        header: key.toUpperCase(),
        key,
        width: 20,
      }));

  sheet.columns = headers;

  data.forEach((item) => {
    const row = {};
    headers.forEach((col) => {
      row[col.key] = item[col.key];
    });
    sheet.addRow(row);
  });

  // Style header
  sheet.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
  sheet.getRow(1).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "4472C4" },
  };

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `${fileName}.xlsx`);
}

/**
 * Generates and downloads PDF from given data
 */
export function exportToPDF(data, fileName = "data", columns = []) {
  const doc = new jsPDF({ orientation: "landscape" });

  const headers = columns.length
    ? columns.map((col) => col.header)
    : Object.keys(data[0] || {});
  const body = data.map((row) =>
    columns.length
      ? columns.map((col) => row[col.accessor])
      : Object.values(row)
  );

  doc.setFontSize(14);
  doc.text(fileName.toUpperCase(), 14, 16);

  autoTable(doc, {
    startY: 20,
    head: [headers],
    body,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [68, 114, 196] },
  });

  doc.save(`${fileName}.pdf`);
}
